module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.avulso) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
  }, [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO RISCO",
      "modal": _vm.showProcedimento,
      "onSave": _vm.inserirProcedimento,
      "isModal": false,
      "width": "50%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Pesquisar risco",
      "items": _vm.bind.procedimentos,
      "loading": _vm.bind.loadingProcedimento,
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getRisco
    },
    model: {
      value: (_vm.bind.procedimento),
      callback: function($$v) {
        _vm.$set(_vm.bind, "procedimento", $$v)
      },
      expression: "bind.procedimento"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações sobre as atividades\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Início das Atividades",
      "name": "valor.ambiente.dtIniCondicao",
      "required": ""
    },
    model: {
      value: (_vm.formData.ambiente.dtIniCondicao),
      callback: function($$v) {
        _vm.$set(_vm.formData.ambiente, "dtIniCondicao", $$v)
      },
      expression: "formData.ambiente.dtIniCondicao"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9",
    attrs: {
      "label": "Descrição das Atividades",
      "name": "valor.Atividades",
      "required": ""
    },
    model: {
      value: (_vm.formData.ambiente.dscAtivDes),
      callback: function($$v) {
        _vm.$set(_vm.formData.ambiente, "dscAtivDes", $$v)
      },
      expression: "formData.ambiente.dscAtivDes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações relativas ao responsável pelos registros ambientais.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Nome do Responsavel",
      "name": "valor.responsavel.nome",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "nome", $$v)
      },
      expression: "formData.responsavel.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "CPF do Responsavel",
      "name": "valor.responsavel.cpfResp",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.cpfResp),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "cpfResp", $$v)
      },
      expression: "formData.responsavel.cpfResp"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Órgão de Classe",
      "items": [{
          id: 1,
          nome: 'Conselho Regional de Medicina - CRM'
        },
        {
          id: 4,
          nome: 'Conselho Regional de Engenharia e Agronomia - CREA'
        },
        {
          id: 9,
          nome: 'Outros'
        } ],
      "name": "valor.responsavel.ideOC"
    },
    model: {
      value: (_vm.formData.responsavel.ideOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "ideOC", $$v)
      },
      expression: "formData.responsavel.ideOC"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Número de Incrição de Classe",
      "name": "valor.responsavel.nrOC",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.nrOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "nrOC", $$v)
      },
      expression: "formData.responsavel.nrOC"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
    attrs: {
      "label": "Unidade Federativa",
      "name": "valor.responsavel.ufOC",
      "items": _vm.parent.bind.estados,
      "required": ""
    },
    model: {
      value: (_vm.formData.responsavel.ufOC),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel, "ufOC", $$v)
      },
      expression: "formData.responsavel.ufOC"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Agente(s) nocivo(s) ao(s) qual(is) o trabalhador está exposto. - Tabela 24\n    do eSocial\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "success",
      "label": "Inserir Novo Risco",
      "title": "Inserir Novo Risco"
    },
    on: {
      "click": function($event) {
        _vm.showProcedimento = !_vm.showProcedimento
      }
    }
  }), _vm._v(" "), _c('b-table-simple', {
    staticClass: "col-12 table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("CÓDIGO")]), _vm._v(" "), _c('b-th', [_vm._v("RISCO")]), _vm._v(" "), _c('b-th', [_vm._v("DESCRIÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("TIPO DE AVALIAÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("INTENSIDADE OU CONCENTRAÇÃO")]), _vm._v(" "), _c('b-th', [_vm._v("LIMITE DE TOLERÂNCIA")]), _vm._v(" "), _c('b-th', [_vm._v("UNIDADE DE MEDIDA")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [(!_vm.formData.riscos.length) ? _c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(" Nenhum risco cadastrado ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.riscos), function(risco, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_vm._v("\n              " + _vm._s(risco.codigo) + "\n            ")]), _vm._v(" "), _c('b-td', [_vm._v("\n              " + _vm._s(risco.nome) + "\n            ")]), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      key: 'dscAgNoc-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.dscAgNoc),
        callback: function($$v) {
          _vm.$set(risco, "dscAgNoc", $$v)
        },
        expression: "risco.dscAgNoc"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      key: 'tpAval-' + index,
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'Critério quantitativo'
          },
          {
            id: 2,
            nome: 'Critério qualitativo'
          } ]
      },
      model: {
        value: (risco.tpAval),
        callback: function($$v) {
          _vm.$set(risco, "tpAval", $$v)
        },
        expression: "risco.tpAval"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      key: 'intConc-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.intConc),
        callback: function($$v) {
          _vm.$set(risco, "intConc", $$v)
        },
        expression: "risco.intConc"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-text', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('money'),
        expression: "'money'"
      }],
      key: 'limTol-' + index,
      staticStyle: {
        "with": "100%"
      },
      model: {
        value: (risco.limTol),
        callback: function($$v) {
          _vm.$set(risco, "limTol", $$v)
        },
        expression: "risco.limTol"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      key: 'unMed-' + index,
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'dose diária de ruído'
          },
          {
            id: 2,
            nome: 'decibel linear (dB (linear))'
          },
          {
            id: 3,
            nome: 'decibel (C) (dB(C))'
          },
          {
            id: 4,
            nome: 'decibel (A) (dB(A))'
          },
          {
            id: 5,
            nome: 'metro por segundo ao quadrado (m/s2)'
          },
          {
            id: 6,
            nome: 'metro por segundo elevado a 1,75 (m/s1,75)'
          },
          {
            id: 7,
            nome: 'parte de vapor ou gás por milhão de partes de ar contaminado (ppm)'
          },
          {
            id: 8,
            nome: 'miligrama por metro cúbico de ar (mg/m3)'
          },
          {
            id: 9,
            nome: 'fibra por centímetro cúbico (f/cm3)'
          },
          {
            id: 10,
            nome: 'grau Celsius (ºC)'
          },
          {
            id: 11,
            nome: 'metro por segundo (m/s)'
          },
          {
            id: 12,
            nome: 'porcentual'
          },
          {
            id: 13,
            nome: 'lux (lx)'
          },
          {
            id: 14,
            nome: 'unidade formadora de colônias por metro cúbico (ufc/m3)'
          },
          {
            id: 15,
            nome: 'dose diária'
          },
          {
            id: 16,
            nome: 'dose mensal'
          },
          {
            id: 17,
            nome: 'dose trimestral'
          },
          {
            id: 18,
            nome: 'dose anual'
          },
          {
            id: 19,
            nome: 'watt por metro quadrado (W/m2)'
          },
          {
            id: 20,
            nome: 'ampère por metro (A/m)'
          },
          {
            id: 21,
            nome: 'militesla (mT)'
          },
          {
            id: 22,
            nome: 'microtesla (μT)'
          },
          {
            id: 23,
            nome: 'miliampère (mA)'
          },
          {
            id: 24,
            nome: 'quilovolt por metro (kV/m)'
          },
          {
            id: 25,
            nome: 'volt por metro (V/m)'
          },
          {
            id: 26,
            nome: 'joule por metro quadrado (J/m2)'
          },
          {
            id: 27,
            nome: 'milijoule por centímetro quadrado (mJ/cm2)'
          },
          {
            id: 28,
            nome: ' milisievert (mSv)'
          },
          {
            id: 29,
            nome: 'milhão de partículas por decímetro cúbico (mppdc)'
          },
          {
            id: 30,
            nome: 'umidade relativa do ar (UR (%))'
          } ],
        "required": risco.tpAval == 1
      },
      model: {
        value: (risco.unMed),
        callback: function($$v) {
          _vm.$set(risco, "unMed", $$v)
        },
        expression: "risco.unMed"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "title": "Remover Novo risco"
      },
      on: {
        "click": function($event) {
          return _vm.removerProcedimento(index)
        }
      }
    })], 1)], 1)
  })], 2)], 1)], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a93b6f1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/s2240.vue
// module id = 1534
// module chunks = 45